import { ElMessage } from "element-plus";
import cookie from "@/assets/js/cookie";

export default {
  /**
   * 获取域名地址
   * @returns 地址
   */
  hostAddress() {
    let origin = document.location.origin;
    if (
      origin.indexOf("localhost") >= 0 ||
      origin.indexOf("127.0.0.1") >= 0 ||
      origin.indexOf("192.168.0.131") >= 0
    ) {
      origin = "http://39.99.190.219";
    }
    return origin;
  },
  /**
   * 获取域名地址
   * @returns 地址
   */
  hostWsAddress() {
    let origin = document.location.host;
    let agreement = origin.indexOf('3goodsoft') >= 0 ?  'wss' : 'ws';
    if (
      origin.indexOf("localhost") >= 0 ||
      origin.indexOf("127.0.0.1") >= 0 ||
      origin.indexOf("192.168.0.131") >= 0
    ) {
      origin = "39.99.190.219";
    }

    return agreement + '://' + origin;
  },

  kUserAgent() {
    return {
      Opera: "Opera",
      FF: "FF",
      Chrome: "Chrome",
      Safari: "Safari",
      IE: "IE",
    };
  },

  /**
   * 判断浏览器类型
   * @returns 浏览器类型
   */
  getUserAgent() {
    const { userAgent } = navigator;
    if (userAgent.indexOf("Opera") > -1) {
      return this.kUserAgent().Opera;
    }
    if (userAgent.indexOf("Firefox") > -1) {
      return this.kUserAgent().FF;
    }
    if (userAgent.indexOf("Chrome") > -1) {
      return this.kUserAgent().Chrome;
    }
    if (userAgent.indexOf("Safari") > -1) {
      return this.kUserAgent().Safari;
    }
    if (
      userAgent.indexOf("compatible") > -1 &&
      userAgent.indexOf("MSIE") > -1 &&
      userAgent.indexOf("Opera") > -1
    ) {
      return this.kUserAgent().IE;
    }
  },

  /**
   * 判断字符串是否为空
   * @param {字符串} str
   * @returns 布尔值
   */
  isEmptyString(str) {
    let isEmpty = false;
    if (str == null) {
      isEmpty = true;
    } else {
      let g = str.toString().replace(/\s*/g, "");
      if (g.length === 0) {
        isEmpty = true;
      } else {
        isEmpty = false;
      }
    }
    return isEmpty;
  },

  /**
   * 判断字符串是否是数字
   * @param {字符串} str
   * @returns 布尔值
   */
  isNumber(str) {
    let numReg = new RegExp(/^[0-9]*$/);
    if (numReg.test(str)) {
      return true;
    }
    return false;
  },

  /**
   * 验证身份证号码是否合法
   * @param {身份证号码} idcard
   * @returns 结果对象
   */
  checkIdCardNum: (idcard) => {
    var Errors = [
      { status: 0, msg: "验证通过!" },
      { status: 1, msg: "身份证号码位数不对!" },
      { status: 2, msg: "身份证号码出生日期超出范围或含有非法字符!" },
      { status: 3, msg: "身份证号码校验错误!" },
      { status: 4, msg: "身份证地区非法!" },
    ];
    var area = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外",
    };
    var ereg;
    var idcard_array = idcard.split("");
    // @ts-ignore
    if (area[parseInt(idcard.substr(0, 2))] === null) return Errors[4];
    switch (idcard.length) {
      case 15:
        if (
          (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0 ||
          ((parseInt(idcard.substr(6, 2)) + 1900) % 100 === 0 &&
            (parseInt(idcard.substr(6, 2)) + 1900) % 4 === 0)
        ) {
          ereg =
            /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
          //测试出生日期的合法性
        } else {
          ereg =
            /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
          //测试出生日期的合法性
        }
        if (ereg.test(idcard)) return Errors[0];
        else return Errors[2];
      case 18:
        if (
          parseInt(idcard.substr(6, 4)) % 4 == 0 ||
          (parseInt(idcard.substr(6, 4)) % 100 == 0 &&
            parseInt(idcard.substr(6, 4)) % 4 == 0)
        ) {
          ereg =
            /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
          //闰年出生日期的合法性正则表达式
        } else {
          ereg =
            /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
          //平年出生日期的合法性正则表达式
        }
        if (ereg.test(idcard)) {
          var S =
            (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 +
            (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 +
            (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 +
            (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 +
            (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 +
            (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 +
            (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 +
            parseInt(idcard_array[7]) * 1 +
            parseInt(idcard_array[8]) * 6 +
            parseInt(idcard_array[9]) * 3;
          var Y = S % 11;
          var M = "F";
          var JYM = "10X98765432";
          M = JYM.substr(Y, 1);
          if (M == idcard_array[17]) return Errors[0];
          else return Errors[3];
        } else return Errors[2];
      default:
        return Errors[1];
    }
  },

  /**
   * 通过邮箱获取官网链接
   * @param {邮箱地址} email
   * @returns 邮箱官网链接
   */
  emailUrlLink(email) {
    let t = email.split("@")[1];
    t = t.toLowerCase();
    if (t == "163.com") {
      return "mail.163.com";
    } else if (t == "vip.163.com") {
      return "vip.163.com";
    } else if (t == "126.com") {
      return "mail.126.com";
    } else if (t == "qq.com" || t == "vip.qq.com" || t == "foxmail.com") {
      return "mail.qq.com";
    } else if (t == "gmail.com") {
      return "mail.google.com";
    } else if (t == "sohu.com") {
      return "mail.sohu.com";
    } else if (t == "tom.com") {
      return "mail.tom.com";
    } else if (t == "vip.sina.com") {
      return "vip.sina.com";
    } else if (t == "sina.com.cn" || t == "sina.com") {
      return "mail.sina.com.cn";
    } else if (t == "tom.com") {
      return "mail.tom.com";
    } else if (t == "yahoo.com.cn" || t == "yahoo.cn") {
      return "mail.cn.yahoo.com";
    } else if (t == "tom.com") {
      return "mail.tom.com";
    } else if (t == "yeah.net") {
      return "www.yeah.net";
    } else if (t == "21cn.com") {
      return "mail.21cn.com";
    } else if (t == "hotmail.com") {
      return "www.hotmail.com";
    } else if (t == "sogou.com") {
      return "mail.sogou.com";
    } else if (t == "188.com") {
      return "www.188.com";
    } else if (t == "139.com") {
      return "mail.10086.cn";
    } else if (t == "189.cn") {
      return "webmail15.189.cn/webmail";
    } else if (t == "wo.com.cn") {
      return "mail.wo.com.cn/smsmail";
    } else if (t == "139.com") {
      return "mail.10086.cn";
    } else {
      return "";
    }
  },

  /**
   * 截取日期字符串
   * @param {日期字符串} dateString  xxxx-xx-xx xx:xx:xx
   * @returns xxxx-xx-xx
   */
  cutDateString(dateString) {
    if (dateString != null && dateString.length > 0) {
      if (dateString.length <= 10) {
        return dateString;
      } else {
        return dateString.substr(0, 10);
      }
    } else {
      return "";
    }
  },

  /**
   * 限制上传图片格式和大小
   * @param {文件对象} file
   * @param {限制大小} size
   * @param {提示信息前缀} tipString
   * @returns
   */
  uploadImageCheck(file, size, tipString) {
    const isJPG = file.type === "image/jpg";
    const isPng = file.type === "image/png";
    const isJpeg = file.type === "image/jpeg";

    //1MB=1024*1024(1MB=1024KB 1KB=1024MB)
    const is5M = file.size / 1024 / 1024 < size;

    //限制文件上传类型
    if (!isJPG && !isPng && !isJpeg) {
      ElMessage.error(tipString + "只能是图片(如:png,jpg,jpeg格式)!");
      return false;
    }

    //限制文件上传大小
    if (!is5M) {
      ElMessage.error(tipString + "大小不能超过" + size + "MB!");
      return false;
    }

    return true;
  },

  /**
   * 毫秒转时分秒
   * @param {毫秒数} interval
   */
  millisecondFormat(interval) {
    let t = interval / 1000;
    let d = Math.floor(t / (24 * 3600));
    let h = Math.floor((t - 24 * 3600 * d) / 3600) + d * 24;
    let m = Math.floor((t - 24 * 3600 * d - h * 3600) / 60);
    let s = Math.floor(t - 24 * 3600 * d - h * 3600 - m * 60);

    let hou = h > 0 ? `${h}时` : "";
    let min = m > 0 ? `${m}分` : "";
    let sec = s > 0 ? `${s}秒` : "0秒";
    return (hou.length > 0 ? hou : "") + (min.length > 0 ? min : "") + sec;
  },

  /**
   * 通过文件后缀获取文件路径
   * @param {文件名} fileName
   */
  getFilePathWithSuffix(fileName) {
    let vals = fileName.split(".")[1];
    if (vals == "doc" || vals == "docx") {
      return "/file/words/" + fileName;
    } else if (vals == "xls" || vals == "xlsx") {
      return "/file/excels/" + fileName;
    } else if (vals == "pdf") {
      return "/file/pdfs/" + fileName;
    } else if (vals == "ppt") {
      return "/file/ppts/" + fileName;
    }  else if (vals == "pptx") {
      return "/file/ppts/" + fileName;
    } else if (
      vals == "jpg" ||
      vals == "jpeg" ||
      vals == "png" ||
      vals == "gif"
    ) {
      return "/file/images/" + fileName;
    } else {
      return "";
    }
  },

  /**
   * 文件下载
   * @param {文件路径<含文件后缀名>} filePath
   */
  fileDownload(filePath) {
    let origin = document.location.origin;
    let fileUrl = "";
    if (
      origin.indexOf("localhost") >= 0 ||
      origin.indexOf("127.0.0.1") >= 0
    ) {
      fileUrl = "/api" + this.getFilePathWithSuffix(filePath);
    } else {
      fileUrl = this.getFilePathWithSuffix(filePath);
    }

    let ajax = new XMLHttpRequest();
    ajax.open("GET", fileUrl, true);
    ajax.setRequestHeader("Cache-Control", "no-cache");
    ajax.setRequestHeader("Access-Control-Allow-Origin", "*");
    ajax.responseType = "blob";
    ajax.onload = (e) => {
      let res = e.target.response;
      let blob = new Blob([res]);
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.download = filePath; // 下载文件的名称，必须带文件后缀
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
    };
    ajax.send();
  },

  /**
   * 日期转字符串
   * @param {日期} date
   * @returns
   */
  dateToString(date) {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();
    let hours = date.getHours().toString();
    let min = date.getMinutes().toString();
    let second = date.getSeconds().toString();
    if (month.length == 1) {
      month = "0" + month;
    }
    if (day.length == 1) {
      day = "0" + day;
    }
    if (hours.length == 1) {
      hours = "0" + hours;
    }
    if (min.length == 1) {
      min = "0" + min;
    }
    if (second.length == 1) {
      second = "0" + second;
    }

    return `${year}-${month}-${day} ${hours}:${min}:${second}`;
  },

  /**
   * 日期字符串转数字串
   * @param {日期字符串} dateString
   * @returns
   */
  dateToNumString(dateString) {
    let time = dateString.replaceAll("-", "");
    time = time.replaceAll(" ", "");
    time = time.replaceAll(":", "");
    return time;
  },

  /**
   * 获取地址栏参数值字典
   */
  getQueryVariableDict() {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    let dict = {};
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split("=");
      dict[pair[0]] = pair[1];
    }
    return dict;
  },

  /**
   * 设置页签title和favicon
   */
  setDocumentTabTitle() {
    let college = "";
    let schoolLogo = "";

    let collegeConfig = JSON.parse(sessionStorage.getItem("kSysCollegeConfig"));
    if (collegeConfig != null && Object.keys(collegeConfig).length > 0) {
      if (!this.isEmptyString(collegeConfig.collegetag)) {
        college = collegeConfig.collegetag;
      }

      if (!this.isEmptyString(collegeConfig.schoolLogo)) {
        schoolLogo = collegeConfig.schoolLogo || "";
      }
    }

    if (this.isEmptyString(college)) {
      document.title = "三好锐课";
    } else {
      document.title = decodeURIComponent(college);
    }

    let logoUrl = "";
    if (!this.isEmptyString(schoolLogo)) {
      if (collegeConfig != null) {
        logoUrl = this.hostAddress() + "/file/images/" + schoolLogo;
      }
    } else {
      logoUrl = '/favicon.ico';
    }
    let favicon = document.querySelector('link[rel="icon"]');
    if (favicon !== null) {
      favicon.href = logoUrl;
    } else {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.href = logoUrl;
      document.head.appendChild(favicon);
    }
  },

  /**
   * 设置地址栏院校参数
   */
  setAddressCollegeParams(pathDict) {
    let college = "";
    let dict = this.getQueryVariableDict();
    if (
      dict != null &&
      Object.keys(dict).length > 0 &&
      !this.isEmptyString(dict.college)
    ) {
      college = dict.college;
    }

    let collegeConfig = JSON.parse(sessionStorage.getItem("kSysCollegeConfig"));
    if (collegeConfig != null && Object.keys(collegeConfig).length > 0) {
      if (this.isEmptyString(college)) {
        if (!this.isEmptyString(collegeConfig.collegetag)) {
          college = collegeConfig.collegetag;
        }
      }
    }

    dict.college = college;

    let paramsString = "";
    for (var k in dict) {
      let value = dict[k] !== undefined ? dict[k] : "";
      paramsString += `&${k}=${encodeURIComponent(value)}`;
    }
    paramsString = paramsString ? paramsString.substring(1) : "";

    let url = `${window.location.origin}${window.location.pathname}?${paramsString}`;
    window.history.replaceState(
      {
        path: url,
      },
      "",
      url
    );
  },

  /**
   * 跳转至职业技能中心
   * @param {参数类型数据} item 
   */
  campusJumpSkill(item) {
    let userInfo = JSON.parse(cookie.getCookie("college_user"));
    let college = userInfo.college || '';
    let token = userInfo.token || '';
    let userCuid = userInfo.userid || '';
    let userType = userInfo.userType || '';
    let classType = userInfo.classType;
    let classCuid = userInfo.classCuid;
    let type = "";
    switch (item.name) {
      case '1+X建筑工程':
        type = "1Puls";
        break;
      case '1+X交通土建':
        type = "jiao";
        break;
      case '学生组':
        type = "student";
        break;
      case '铁路桥梁隧道工程数字化施工':
        type = "railwayTunnel";
        break;
      case '城市轨道工程数字化施工':
        type = "urbanTrack";
        break;
      case '土木建筑智能建造':
        type = "engineeringIntelligence";
        break;
      case '公路桥梁工程数字化施工':
        type = "trafficDigitize";
        break;
      case '职工组':
        type = "teacher";
        break;
      default:
        break;
    }

    setTimeout(() => {
      window.open(`${this.hostAddress()}/skill?s_type=${type}&s_c=${college}&s_t=${token}&s_uc=${userCuid}&s_ct=${classType}&s_ut=${userType}&s_ucc=${classCuid}&s_menuType=mock&s_mockIndex=0&s_historyMenuIndex=0&s_mockItemIndex=1&s_caseIndex=0&s_caseItemIndex=1`);
    }, 250);
  },

  /**
   * 跳转至职业技能中心
   * @param {参数类型数据} item 
   */
   campusJumpSkillCarbon(item) {
    let userInfo = JSON.parse(cookie.getCookie("college_user"));
    let college = userInfo.college || '';
    let token = userInfo.token || '';
    let userCuid = userInfo.userid || '';
    let userType = userInfo.userType || '';
    let classType = userInfo.classType;
    let classCuid = userInfo.classCuid;

    setTimeout(() => {
      window.open(`${this.hostAddress()}/skillCarbon?s_c=${college}&s_t=${token}&s_uc=${userCuid}&s_ct=${classType}&s_ut=${userType}&s_ucc=${classCuid}&s_menuType=carbon&s_carbonItemIndex=1`);
    }, 250);
  },
  
};
